import { type ReactNode, createContext, useContext } from 'react';

interface RouterContextInterface {
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleNavigation: (...args: any[]) => any;
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleOffRouteChange: (...args: any[]) => any;
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleOnRouteChange: (...args: any[]) => any;
}

const RouterContext = createContext<RouterContextInterface | null>(null);

type RouterProviderProps = {
  children?: ReactNode;
} & RouterContextInterface;

export function RouterProvider({
  children,
  handleNavigation,
  handleOffRouteChange,
  handleOnRouteChange
}: RouterProviderProps) {
  return (
    <RouterContext.Provider
      value={{ handleNavigation, handleOffRouteChange, handleOnRouteChange }}
    >
      {children}
    </RouterContext.Provider>
  );
}

export function useCustomRouter() {
  const context = useContext(RouterContext);
  if (context == null) {
    throw new Error('useCustomRouter must be used within RouterProvider');
  }

  return context;
}
